import swal from "@sweetalert/with-react";
/**
 * @author      Suyog Manandhar
 * @version     2.0
 * @description This class, RecruitmentForm, render the Recruitment Form with respect to the JSON input
 */
import { cloneDeep } from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Spinner } from "reactstrap";
import "../../../assets/scss/recruitment.scss";
import {
	getRecruitmentConfiguration,
	getStaffList,
	getStaffListPagination,
} from "../../../ducks/RecruitmentDucks";
import { axiosPost } from "../../../utils/AxiosApi";
import {
	URL,
	addressCode,
	checkWidgetAdminOrNot,
	peopleCode,
} from "../../../utils/Constants";
import { MESSAGEHEADER } from "../../../utils/DisplayMessage";
import { convertNepaliDate, emailValidate } from "../../../utils/Utils";
import AddressCluster from "../../Admission/AddressCluster";
import TableForm from "../../Admission/Admission/TableForm";
import IdentityCluster from "../../Admission/IdentityCluster";
import GranularPermissionModal from "./../../Permissions/GranularPermissionModal";
import ModalWindow from "./../../UI/ModalWindow";
import ImportRecruitment from "./ImportRecruitment";
import StaffType from "./StaffType";
import parsePhoneNumber from "libphonenumber-js";

const { adToBs, bsToAd } = require("@sbmdkl/nepali-date-converter");

class RecruitmentForm extends Component {
	state = {
		addressCustomFields: [],
		addressFields: [],
		academicYear: "",
		admissionTableFieldGroups: [],
		customFields: [],
		customTableFieldValues: [],
		cv: null,
		dateOfBirth: null,
		dateOfHire: "",
		department: "",
		departments: [],
		designation: "",
		designations: [],
		email: null,
		emergencyContactName: "",
		emergencyContactNumber: "",
		errors: {
			staffTypeId: false,
			dateOfHire: false,
			admissionTableFieldGroups: {},
		},
		gender: null,
		identityFields: [],
		isAvailable: false,
		isLoading: true,
		isSubmitting: false,
		maritalStatus: "sing",
		nationality: null,
		recruitmentImage: null,
		reGex: /^[a-zA-Z ]*$/,
		render: false,
		schoolEstablishedDate: "",
		selectedDepartments: null,
		selectedDesignations: null,
		spinner: true,
		staffType: [],
		staffTypeId: "",
		teachingLicense: "no",
		parentCredentials: false,
		userFetching: false,
		username: null,
		userFound: null,
		isEmailAvailable: null,
		emailFetching: false,
		yearOfJoiningToggleDate: false,
		dateOfHireInBS: null,
		identityClusterDatePickerToggle: false,
		importModal: false,
		countryFirstLevelExists: false,
		countrySecondLevelExists: false,
		countryThirdLevelExists: false,
	};

	componentDidMount() {
		const crudName = this.props.editMode ? "update" : "insert";
		const peopleId = this.props.peopleId;
		this.props.getRecruitmentConfiguration(crudName, peopleId);
		this.getCustomFields();
		this.getSchoolInfo();
		this.getStaffType();
		if (this.props.editMode) {
			this.setUpdateConfiguration();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevProps.recruitmentConfiguration !== this.props.recruitmentConfiguration
		) {
			this.setState(
				{
					admissionTableFieldGroups: this.props.recruitmentConfiguration,
					isLoading: false,
				},
				async () => {
					if (this.props.editMode) {
						await this.setUpdateCustomFieldValues();
					}
				},
			);
		}
	}

	/**
	 * Retrieves the identityCluster fields from the database
	 */
	getCustomFields = () => {
		axiosPost(
			URL.getIdentityCluster,
			{
				isConfig: false,
			},
			(response) => {
				if (response.status === 200) {
					const data = response.data.data;
					this.setState({ customFields: data });
				}
			},
		);
		axiosPost(
			URL.getAddressCluster,
			{
				isConfig: false,
			},
			(response) => {
				if (response.status === 200) {
					const data = response.data.data;
					this.setState({ addressCustomFields: data });
				}
			},
		);
	};

	getDepartments = () => {
		axiosPost(
			URL.getDepartment,
			{},
			(response) => {
				if (response.status === 200) {
					let departments = response.data.data;
					departments = departments.map((d) => {
						d.label = d.name;
						d.value = d.id;
						return d;
					});
					this.setState({ departments }, function () {
						if (this.state.departments.length > 0) {
							this.setState({
								isAvailable: true,
								render: true,
								spinner: false,
							});
						} else {
							this.setState({
								isAvailable: false,
								render: true,
								spinner: false,
							});
						}
						this.getDesignations();
					});
				} else {
					this.setState({ isAvailable: false, render: true, spinner: false });
				}
			},
			(err) => {
				this.setState({ isAvailable: false, render: true, spinner: false });
			},
		);
	};

	getDesignations = () => {
		axiosPost(URL.getDesignations, {}, (response) => {
			if (response.status === 200) {
				let designations = response.data.data;
				designations = designations.map((d) => {
					d.label = d.name;
					d.value = d.id;
					return d;
				});
				this.setState({ designations });
			}
		});
	};

	getSchoolInfo = () => {
		axiosPost(URL.getSchoolByKey, {}, (response) => {
			if (response.status === 200) {
				const date = response.data.data.dateOfEstablishment;

				this.setState({
					schoolEstablishedDate:
						date && date !== "" ? moment(date).format("YYYY-MM-DD") : "",
				});
			}
		});
	};

	getStaffType = () => {
		axiosPost(URL.getStaffType, {}, (response) => {
			if (response.status === 200) {
				const staffType = response.data.data;
				this.setState(
					{
						staffType,
					},
					function () {
						this.getDepartments();
					},
				);
			}
		});
	};

	handleBdayChange = (
		e,
		studentFieldIndex,
		customTableFieldIndex,
		stateName,
	) => {
		const bsDate = convertNepaliDate(e.target.value);

		const newState = cloneDeep([...this.state[stateName]]);
		const errors = { ...this.state.errors };
		newState[studentFieldIndex].customTableFields[
			customTableFieldIndex
		].bsDateField = bsDate;
		newState[studentFieldIndex].customTableFields[customTableFieldIndex].year =
			e.target.value.substring(0, 4);
		newState[studentFieldIndex].customTableFields[customTableFieldIndex].month =
			e.target.value.substring(5, 7).substring(0, 1) === "0"
				? e.target.value.substring(6, 7)
				: e.target.value.substring(5, 7);
		newState[studentFieldIndex].customTableFields[customTableFieldIndex].day =
			e.target.value.substring(8, 10).substring(0, 1) === "0"
				? e.target.value.substring(9, 10)
				: e.target.value.substring(8, 10);
		if (e.target.value.length > 0) {
			errors[stateName].year = false;
			errors[stateName].month = false;
			errors[stateName].day = false;
		} else {
			errors[stateName].year = true;
			errors[stateName].month = true;
			errors[stateName].day = true;
		}
		this.setState({ [stateName]: newState, errors });
	};

	checkIfEmailAvailable = (e, email) => {
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const validEmail = re.test(email);
		if (validEmail) {
			const data = {
				username: email,
			};
			this.setState({ emailFetching: true, isEmailAvailable: false }, () => {
				axiosPost(
					URL.isPeopleAvailable,
					data,
					(response) => {
						if (response.status === 200) {
							this.setState({
								isEmailAvailable: response.data.data === null,
								emailFetching: false,
							});
						}
					},
					(err) => {
						this.setState({ isEmailAvailable: false, emailFetching: false });
					},
				);
			});
		} else {
			this.setState({ isEmailAvailable: false });
		}
	};
	updateStateWithValues = async (data) => {
		const customTableFieldValuesByUsername = data.customTableFieldValues;
		const addressFields = data.peopleAddresses;
		const admissionTableFieldGroups = [...this.state.admissionTableFieldGroups];

		//set recruitment image
		const imageURL = URL.imageSelectURL + data.photo;
		const response = await fetch(imageURL);
		const imagedata = await response.blob();
		const metadata = {
			type: "image/jpeg",
		};
		const image =
			data.photo != null ? new File([imagedata], data.photo, metadata) : null;

		for (let i = 0; i < admissionTableFieldGroups.length; i++) {
			const group = admissionTableFieldGroups[i];
			const customTableFields = group.customTableFields;
			for (let j = 0; j < customTableFields.length; j++) {
				const field = customTableFields[j];
				if (field.fieldTypeCode === "pre-peop") {
					field.gender = data.gender;
					field.nationality = data.nationality;
					field.email = data.emailAddress;
					field.mobileNumber = data?.mobileNumber;
					field.year = new Date(data.dateOfBirth).getFullYear();
					field.month = new Date(data.dateOfBirth).getMonth() + 1;
					field.day = new Date(data.dateOfBirth).getDate();
					if (
						(field.email && field.email != null) ||
						(field.email && field.email !== "")
					) {
						this.checkIfEmailAvailable(null, data.emailAddress);
					}
					for (const fieldU of customTableFieldValuesByUsername) {
						if (fieldU.dbTableCode === "tbl-ppl") {
							field[fieldU.customTableFieldName] = fieldU.value;
						}
					}
				}
				for (let k = 0; k < addressFields.length; k++) {
					const addressField = addressFields[k];
					if (field.fieldTypeCode === "pre-addr") {
						//
						for (const fieldU of customTableFieldValuesByUsername) {
							if (fieldU.dbTableCode === "tbl-add") {
								field[fieldU.customTableFieldName] = fieldU.value;
							}
						}

						//
						field.country = addressField.countryId;
						field.countryFirstLevelId = addressField.countryFirstLevelId;
						field.countrySecondLevelId = addressField.countrySecondLevelId;
						field.countryThirdLevelId = addressField.countryThirdLevelId;
						const countryFirstLevelPromise = new Promise((res, rej) => {
							axiosPost(
								URL.getCountryFirstLevel,
								{
									countryId: addressField.countryId,
								},
								(response) => {
									if (response.status === 200) {
										res(response.data.data);
									}
								},
							);
						});
						const countryFirstLevel = await countryFirstLevelPromise;
						if (countryFirstLevel) {
							field.countryFirstLevel = countryFirstLevel;
						}
						const countrySecondLevelPromise = new Promise((res, rej) => {
							axiosPost(
								URL.getCountrySecondLevel,
								{
									countryId: addressField.countryId,
									countryFirstLevelId: addressField.countryFirstLevelId,
								},
								(response) => {
									if (response.status === 200) {
										res(response.data.data);
									}
								},
							);
						});
						const countrySecondLevel = await countrySecondLevelPromise;
						if (countrySecondLevel) {
							field.countrySecondLevel = countrySecondLevel;
						}
						const countryThirdLevelPromise = new Promise((res, rej) => {
							axiosPost(
								URL.getCountryThirdLevel,
								{
									countryId: addressField.countryId,
									countryFirstLevelId: addressField.countryFirstLevelId,
									countrySecondLevelId: addressField.countrySecondLevelId,
								},
								(response) => {
									if (response.status === 200) {
										res(response.data.data);
									}
								},
							);
						});
						const countryThirdLevel = await countryThirdLevelPromise;
						if (countryThirdLevel) {
							field.countryThirdLevel = countryThirdLevel;
						}
					}
				}
			}
		}

		this.setState({
			admissionTableFieldGroups,
			recruitmentImage: image,
			customTableFieldValuesByUsername,
		});
	};

	checkisUserAvailable = () => {
		const data = {
			username: this.state.username,
		};
		this.setState({ userFetching: true, userFound: false }, () => {
			axiosPost(
				URL.isPeopleAvailable,
				data,
				(response) => {
					if (response.status === 200) {
						this.setState({
							userFound: response.data.data !== null,
							userFetching: false,
						});
						response.data.data &&
							this.updateStateWithValues(response.data.data);
					}
				},
				(err) => {
					this.setState({ userFound: false, userFetching: false });
				},
			);
		});
	};

	/**
	 * This methods binds the input fields with its respective state, say value
	 */
	handleChange = (e) => {
		const target = e.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;
		const errors = { ...this.state.errors };
		if (value.length > 0) {
			errors[name] = false;
		} else {
			errors[name] = true;
		}
		this.setState(
			{
				errors,
				userFound:
					name === "username" && value.length === 0
						? null
						: this.state.userFound,
			},
			() => {
				this.setState(
					{
						[name]: value,
					},
					() => {
						if (name === "username") {
							this.checkisUserAvailable(e);
						}
					},
				);
			},
		);
	};

	/**
	 * This handles change in the Identity Cluster Fields
	 * @param  e is the synthetic event
	 * @param idx is the corresponding index of the mapped value
	 */
	handleCustomFieldChange = async (
		e,
		studentFieldIndex,
		customTableFieldIndex,
		stateName,
		fields,
	) => {
		const target = e.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;
		const newState = [...this.state[stateName]];
		const errors = { ...this.state.errors };

		// if (
		//   name === "email" &&
		//   this.state.username !== "" &&
		//   value === this.state.username
		// ) {
		//   //check email value with username
		//   swal({
		//     title: "Warning",
		//     text: "Email Address already exist. ",
		//   });
		//   return;
		// } else {
		newState[studentFieldIndex].customTableFields[customTableFieldIndex][name] =
			value;
		// }

		// newState[studentFieldIndex].customTableFields[customTableFieldIndex][name] =value;

		if (name === "country") {
			const data = {
				countryId: e.target.value,
			};
			newState[studentFieldIndex].customTableFields[
				customTableFieldIndex
			].countryFirstLevelId = "";
			newState[studentFieldIndex].customTableFields[
				customTableFieldIndex
			].countrySecondLevelId = "";
			newState[studentFieldIndex].customTableFields[
				customTableFieldIndex
			].countryThirdLevelId = "";

			const countryFirstLevelPromise = new Promise((res, rej) => {
				axiosPost(URL.getCountryFirstLevel, data, (response) => {
					if (response.status === 200) {
						res(response.data.data);
						if (response?.data?.data?.length > 0) {
							this.setState({ countryFirstLevelExists: true });
						}
						else {
							this.setState({
								countryFirstLevelExists: false,
								countrySecondLevelExists: false,
								countryThirdLevelExists: false
							});
						}
					}
				});
			});

			const countryFirstLevel = await countryFirstLevelPromise;
			if (countryFirstLevel) {
				newState[studentFieldIndex].customTableFields[
					customTableFieldIndex
				].countryFirstLevel = countryFirstLevel;
				newState[studentFieldIndex].customTableFields[
					customTableFieldIndex
				].countrySecondLevel = [];
				newState[studentFieldIndex].customTableFields[
					customTableFieldIndex
				].countryThirdLevel = [];
			}
		}
		if (name === "countryFirstLevelId") {
			const data = {
				countryId:
					newState[studentFieldIndex].customTableFields[customTableFieldIndex]
						.country,
				countryFirstLevelId: e.target.value,
			};

			const countrySecondLevelPromise = new Promise((res, rej) => {
				axiosPost(URL.getCountrySecondLevel, data, (response) => {
					if (response.status === 200) {
						res(response.data.data);
						if (response?.data?.data?.length > 0) {
							this.setState({ countrySecondLevelExists: true });
						}
						else {
							this.setState({
								countrySecondLevelExists: false,
								countryThirdLevelExists: false
							});
						}
					}
				});
			});

			const countrySecondLevel = await countrySecondLevelPromise;
			if (countrySecondLevel)
				newState[studentFieldIndex].customTableFields[
					customTableFieldIndex
				].countrySecondLevel = countrySecondLevel;
			newState[studentFieldIndex].customTableFields[
				customTableFieldIndex
			].countryThirdLevel = [];
		}

		if (name === "countrySecondLevelId") {
			const data = {
				countryId:
					newState[studentFieldIndex].customTableFields[customTableFieldIndex]
						.country,
				countryFirstLevelId:
					newState[studentFieldIndex].customTableFields[customTableFieldIndex]
						.countryFirstLevelId,
				countrySecondLevelId: e.target.value,
			};

			const countryThirdLevelPromise = new Promise((res, rej) => {
				axiosPost(URL.getCountryThirdLevel, data, (response) => {
					if (response.status === 200) {
						res(response.data.data);
						if (response?.data?.data?.length > 0) {
							this.setState({ countryThirdLevelExists: true });
						}
						else {
							this.setState({
								countryThirdLevelExists: false
							});
						}
					}
				});
			});
			const countryThirdLevel = await countryThirdLevelPromise;
			if (countryThirdLevel)
				newState[studentFieldIndex].customTableFields[
					customTableFieldIndex
				].countryThirdLevel = countryThirdLevel;
		}
		if (fields?.mandatory)
			if (value?.length > 0) {
				if (
					newState[studentFieldIndex].customTableFields[customTableFieldIndex]
						.error
				) {
					newState[studentFieldIndex].customTableFields[
						customTableFieldIndex
					].error[fields.fieldName] = false;
				}
			} else {
				if (
					newState[studentFieldIndex].customTableFields[customTableFieldIndex]
						.error
				) {
					newState[studentFieldIndex].customTableFields[
						customTableFieldIndex
					].error[fields.fieldName] = true;
				}
			}
		this.setState({ [stateName]: newState, errors });
	};

	handleCustomFieldTablesChange = (
		e,
		studentFieldIndex,
		customTableFieldIndex,
		columnIndex,
		subColumnIndex,
		rowIndex,
		stateName,
		subColumn,
	) => {
		const newState = cloneDeep(this.state[stateName]);
		const value =
			e.target.type === "checkbox" ? e.target.checked : e.target.value;
		const name = e.target.name;
		if (subColumn) {
			newState[studentFieldIndex].customTableFields[
				customTableFieldIndex
			].customFieldTableColumns[columnIndex].rows[rowIndex][name] = value;
		} else {
			newState[studentFieldIndex].customTableFields[customTableFieldIndex].rows[
				rowIndex
			][name] = value;
		}
		this.setState({ [stateName]: newState });
	};

	handleDateChange = (
		objKey,
		objValue,
		studentFieldIndex,
		customTableFieldIndex,
		stateName,
	) => {
		const newState = cloneDeep([...this.state[stateName]]);
		const errors = { ...this.state.errors };
		newState[studentFieldIndex].customTableFields[customTableFieldIndex][
			objKey
		] = objValue;
		if (objValue) {
			errors[stateName][objKey] = false;
		} else {
			errors[stateName][objKey] = true;
		}
		this.setState({ [stateName]: newState, errors });
	};

	handleDepartmentChange = (items, type) => {
		this.setState({ [type]: items });
	};

	handleDuplicate = (groupIndex, fieldIndex, stateName, subCol, ctfcIndex) => {
		const newState = cloneDeep(this.state[stateName]);
		if (subCol === "subCol") {
			let length =
				newState[groupIndex].customTableFields[fieldIndex]
					.customFieldTableColumns[ctfcIndex].rows.length;
			newState[groupIndex].customTableFields[
				fieldIndex
			].customFieldTableColumns[ctfcIndex].rows.push({
				rowId: length === 0 ? length++ : length,
			});
		} else {
			if (newState[groupIndex].customTableFields[fieldIndex].rows) {
				let length =
					newState[groupIndex].customTableFields[fieldIndex].rows.length;
				newState[groupIndex].customTableFields[fieldIndex].rows.push({
					rowId: length === 0 ? length++ : length,
				});
			}
		}
		this.setState({ [stateName]: newState });
	};

	handleFileChange = (
		e,
		studentFieldIndex,
		customTableFieldIndex,
		stateName,
	) => {
		const data = e.target.files[0];
		if (e.target.accept.includes(data.type)) {
			this.setState({ recruitmentImage: data });
		} else {
			swal(MESSAGEHEADER.error, "Unsupported File Type", "");
		}
	};

	/**
	 * @author Suyog Manandhar
	 *
	 * This method handles Change for nested JSON Object i.e. recruitmentConfiguration
	 * @param e is the event
	 * @param gIdx is the index of the corresponding input field
	 * @param stateName is the name of the state input field binded with
	 * @param fIdx is the index of the 2nd dimension JSON Object i.e. customTableFields
	 */
	handleNestedChange = (e, gIdx, stateName, fIdx) => {
		const newState = [...this.state[stateName]];
		const errors = { ...this.state.errors };
		const target = e.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;
		if (e.target.type === "text") {
			newState[gIdx].customTableFields[fIdx][name] = value;
		} else {
			newState[gIdx].customTableFields[fIdx][name] = value;
		}
		const fieldName = newState[gIdx].customTableFields[fIdx].fieldName;
		if (e.target.value.length > 0) {
			if (newState[gIdx].customTableFields[fIdx].error)
				newState[gIdx].customTableFields[fIdx].error = false;
		} else {
			if (newState[gIdx].customTableFields[fIdx].error)
				newState[gIdx].customTableFields[fIdx].error = true;
		}
		this.setState({
			[stateName]: newState,
			errors,
		});
	};

	handleRemoveDuplicate = (
		groupIndex,
		fieldIndex,
		stateName,
		rowIndex,
		subCol,
		ctfcIndex,
	) => {
		const newState = cloneDeep(this.state[stateName]);
		if (subCol === "subCol") {
			newState[groupIndex].customTableFields[
				fieldIndex
			].customFieldTableColumns[ctfcIndex].rows.splice(rowIndex, 1);
		} else {
			newState[groupIndex].customTableFields[fieldIndex].rows.splice(
				rowIndex,
				1,
			);
		}
		this.setState({ [stateName]: newState });
	};

	toggleDatePicker = () => {
		this.setState(
			{
				yearOfJoiningToggleDate: !this.state.yearOfJoiningToggleDate,
			},
			() => {
				if (this.state.yearOfJoiningToggleDate) {
					if (this?.state?.dateOfHire !== "") {
						const nepalidate = adToBs(this?.state?.dateOfHire);
						// const nepalidate = convertNepaliDate(this.state.dateOfHire);
						this.setState({
							dateOfHireInBS: nepalidate,
						});
					}
				} else {
					this.setState({
						dateOfHireInBS: null,
					});
				}
			},
		);
	};

	// handleChangeNepaliDate = ({ bsDate, adDate }) => {
	//   this.setState({
	//     dateOfHireInBS: bsDate,
	//     dateOfHire: adDate,
	//   });
	// };

	handleChangeNepaliDate = (e) => {
		const adDate = bsToAd(e);
		const bsDate = e;
		this.setState({
			dateOfHireInBS: bsDate,
			dateOfHire: adDate,
		});
	};

	icToggleDatePicker = () => {
		this.setState({
			identityClusterDatePickerToggle:
				!this.state.identityClusterDatePickerToggle,
		});
	};

	handleStaticChange = (e) => {
		let err = 0;
		const name = e.target.name;
		const type = e.target.type;
		const value =
			type === "checkbox"
				? e.target.checked
				: type === "file"
					? e.target.files[0].name.split(".").pop() !== "pdf"
						? err++
						: e.target.files[0]
					: // ? e.target.files[0]
					e.target.value;

		if (err > 0) {
			swal(MESSAGEHEADER.error, "Unsupported File Type", "");
			e.target.value = "";
		} else {
			this.setState({ [name]: value });
		}
	};

	//   renderErrorText = () => {
	//     return <span className="error-text">mandatory field</span>;
	//   };

	setUpdateConfiguration = () => {
		const staffData = this.props.staffData;
		this.setState({
			academicYear: staffData.academicYearId,
			staffTypeId: staffData.staffTypeId,
			dateOfHire: moment(staffData.dateOfHire).format("YYYY-MM-DD"),
			department: staffData.departments[0]?.id,
			designation: staffData.designations[0]?.id,
			recruitmentImage: staffData.people.photo,
			gender: staffData.people.gender,
			nationality: staffData.people.nationality,
			email: staffData.people.emailAddress,
			mobileNumber: staffData?.people?.mobileNumber,
			selectedDepartments:
				staffData.departments.length > 0
					? staffData.departments.map((el) => ({
						name: el.details,
						label: el.name,
						id: el.id,
					}))
					: [],
			selectedDesignations:
				staffData.designations.length > 0
					? staffData.designations.map((el) => ({
						name: el.details,
						label: el.name,
						id: el.id,
					}))
					: [],
		});
	};

	setUpdateCustomFieldValues = () => {
		const fieldGroups = [...this.state.admissionTableFieldGroups];
		if (fieldGroups.length > 0) {
			for (const el of fieldGroups) {
				if (el.customTableFields.length > 0) {
					for (const field of el.customTableFields) {
						if (field.fieldTypeCode === "pre-peop") {
							field.gender = this.props.staffData.people.gender;
							field.nationality = this.props.staffData.people.nationality;
							field.email = this.props.staffData.people.emailAddress;
							field.mobileNumber = this.props?.staffData?.people?.mobileNumber;
							const dob = new Date(this.props.staffData.people.dateOfBirth);
							field.year = dob.getFullYear();
							field.month = dob.getMonth() + 1;
							field.day = dob.getDate();

							if (field.customTableFieldValues) {
								for (const v of field.customTableFieldValues) {
									field[v.customTableFieldName] = v.value;
								}
							}
						}

						if (field.fieldTypeCode === "table") {
							for (const column of field.customFieldTableColumns) {
								if (column.customFieldTableSubColumns.length === 0) {
									for (const value of column.customFieldTableColumnValues) {
										const index = field.rows.findIndex(
											(row) => row.rowId === value.rowId,
										);
										if (index !== -1) {
											field.rows[index][column.name] = value.value;
										} else {
											field.rows.push({
												rowId: value.rowId,
												[column.name]: value.value,
											});
										}
									}
								} else {
									for (const subCol of column.customFieldTableSubColumns) {
										for (const value of subCol.customFieldTableColumnValues) {
											const index = column.rows.findIndex(
												(row) => row.rowId === value.rowId,
											);
											if (index !== -1) {
												column.rows[index][subCol.name] = value.value;
											} else {
												column.rows.push({
													rowId: value.rowId,
													[subCol.name]: value.value,
												});
											}
										}
									}
								}
							}
						}

						if (field.fieldTypeCode === "radio") {
							field[`value${field.id}`] = field.value;
						}
					}
				}
			}
		}
		this.setState({ admissionTableFieldGroups: fieldGroups }, async () => {
			const newadmissionTableFieldGroups = [
				...this.state.admissionTableFieldGroups,
			];

			//the use of gold old for loop is to keep the async await working inside a loop;
			// cause forEach failed to do so
			for (let i = 0; i < newadmissionTableFieldGroups.length; i++) {
				const group = newadmissionTableFieldGroups[i];
				const customTableFields = group.customTableFields;
				for (let j = 0; j < customTableFields.length; j++) {
					const customTableField = customTableFields[j];

					if (customTableField.customTableFieldValues) {
						for (const v of customTableField.customTableFieldValues) {
							customTableField[v.customTableFieldName] = v.value;
						}
					}
					if (this.props.staffData?.people?.peopleAddresses) {
						for (
							let k = 0;
							k < this.props.staffData.people.peopleAddresses.length;
							k++
						) {
							const addressField =
								this.props.staffData.people.peopleAddresses[k];
							if (
								customTableField.id === addressField.customTableFieldId &&
								customTableField.fieldTypeCode === "pre-addr"
							) {
								customTableField.country = addressField.countryId;
								customTableField.countryFirstLevelId =
									addressField.countryFirstLevelId;
								customTableField.countrySecondLevelId =
									addressField.countrySecondLevelId;
								customTableField.countryThirdLevelId =
									addressField.countryThirdLevelId;
								const countryFirstLevelPromise = new Promise((res, rej) => {
									axiosPost(
										URL.getCountryFirstLevel,
										{
											countryId: addressField.countryId,
										},
										(response) => {
											if (response.status === 200) {
												res(response.data.data);
											}
										},
									);
								});
								const countryFirstLevel = await countryFirstLevelPromise;
								if (countryFirstLevel) {
									customTableField.countryFirstLevel = countryFirstLevel;
								}
								const countrySecondLevelPromise = new Promise((res, rej) => {
									axiosPost(
										URL.getCountrySecondLevel,
										{
											countryId: addressField.countryId,
											countryFirstLevelId: addressField.countryFirstLevelId,
										},
										(response) => {
											if (response.status === 200) {
												res(response.data.data);
											}
										},
									);
								});
								const countrySecondLevel = await countrySecondLevelPromise;
								if (countrySecondLevel) {
									customTableField.countrySecondLevel = countrySecondLevel;
								}
								const countryThirdLevelPromise = new Promise((res, rej) => {
									axiosPost(
										URL.getCountryThirdLevel,
										{
											countryId: addressField.countryId,
											countryFirstLevelId: addressField.countryFirstLevelId,
											countrySecondLevelId: addressField.countrySecondLevelId,
										},
										(response) => {
											if (response.status === 200) {
												res(response.data.data);
											}
										},
									);
								});
								const countryThirdLevel = await countryThirdLevelPromise;
								if (countryThirdLevel) {
									customTableField.countryThirdLevel = countryThirdLevel;
								}
							}
						}
					}
				}
			}
			this.setState({
				admissionTableFieldGroups: newadmissionTableFieldGroups,
			});
		});
	};

	staffStatus = () => {
		axiosPost(URL.getRecruitmentStatus, {}, (response) => {
			if (response.status === 200) {
				this.setState({ staffStatus: response.data.data }, function () {
					const status = this.state.staffStatus;
					let id = "";
					for (const el of status) {
						if (el.name === "Current") {
							id = el.id;
							break; // exit early since we found the match
						}
					}

					this.setState({ recruitmentStatusId: id }, function () {
						!this.props.editMode &&
							this.props.getStaffListPagination(
								this.state.recruitmentStatusId,
								this.state.offset,
								this.state.pageSize,
							);
					});
				});
			}
		});
	};

	// static getDerivedStateFromProps(nextProps, prevState) {
	//   if (
	//     prevState.admissionTableFieldGroups !== nextProps.recruitmentConfiguration
	//   ) {
	//     return {
	//       admissionTableFieldGroups: nextProps.recruitmentConfiguration,
	//       isLoading: false,
	//     };
	//   }
	// }

	/**
	 * This method is invoked on clicking submit button
	 */
	submit = (e) => {
		e.preventDefault();

		//validation for mandatory fields
		const errorFields = [];
		const newAdmissionTableFieldGroups = [
			...this.state.admissionTableFieldGroups,
		];
		const newErrors = { ...this.state.errors };

		const staticFields = [
			"academicYear",
			"staffTypeId",
			"dateOfHire",
			// "department",
			// "designation",
		];
		for (const field of staticFields) {
			if (this.state[field] === "") {
				errorFields.push(field);
				newErrors[field] = true;
			}
		}

		// if (
		//   this.state.selectedDepartments === null ||
		//   this.state.selectedDepartments == []
		// ) {
		//   errorFields.push("department");
		//   newErrors["department"] = true;
		// }

		if (
			this.state.selectedDesignations === null ||
			this.state.selectedDesignations.length === 0
		) {
			errorFields.push("designation");
			newErrors.designation = true;
		}

		for (const config of newAdmissionTableFieldGroups) {
			for (const field of config.customTableFields) {
				// General field validation
				if (
					field.fieldTypeCode !== addressCode &&
					field.fieldTypeCode !== peopleCode
				) {
					if (
						field.isMandatory &&
						(field.value === "" || field.value === null)
					) {
						errorFields.push(`${field.fieldName} `);
						field.error = true;
					}
				}

				// People field validation
				if (field.fieldTypeCode === peopleCode) {
					field.error = {};
					for (const cField of this.state.customFields) {
						if ((field[cField.fieldName] === undefined || field[cField.fieldName] === "") && cField.isMandatory) {
							errorFields.push(`${cField.fieldName} `);
							field.error[cField.fieldName] = true;
						}
					}
				}

				// Address field validation
				if (field.fieldTypeCode === addressCode) {
					field.error = {};
					if (
						!field.country ||
						field.country === "" ||
						field.country === null
					) {
						errorFields.push("Country");
						field.error.stdCountry = true;
					} else {
						if (field.countryFirstLevelId == undefined) {
							errorFields.push("Student's Province");
							field.error.stdProvince = true;
						}
						if (field.countrySecondLevelId == undefined) {
							errorFields.push("Student's District");
							field.error.stdDistrict = true;
						}
						if (field.countryThirdLevelId == undefined) {
							errorFields.push("Student's City");
							field.error.stdCity = true;
						}

						if (
							field.countryFirstLevelId === "" &&
							this.state.countryFirstLevelExists
						) {
							errorFields.push("Province");
							field.error.stdProvince = true;
						}

						if (
							field.countrySecondLevelId === "" &&
							this.state.countrySecondLevelExists
						) {
							errorFields.push("District");
							field.error.stdDistrict = true;
						}

						if (
							field.countryThirdLevelId === "" &&
							this.state.countryThirdLevelExists
						) {
							errorFields.push("City");
							field.error.stdCity = true;
						}
					}

					for (const aField of this.state.addressCustomFields) {
						if ((field[aField.fieldName] === undefined || field[aField.fieldName] === "") && aField.isMandatory) {
							errorFields.push(`${aField.fieldName} `);
							field.error[aField.fieldName] = true;
						}
					}
				}
			}
		}

		for (let i = 0; i < this.state.admissionTableFieldGroups.length; i++) {
			for (
				let j = 0;
				j < this.state.admissionTableFieldGroups[i].customTableFields.length;
				j++
			) {
				const field =
					this.state.admissionTableFieldGroups[i].customTableFields[j];
				if (
					this.state.admissionTableFieldGroups[i].customTableFields[j]
						.fieldTypeCode === peopleCode
				) {
					if (!field.year) {
						newErrors.admissionTableFieldGroups.year = true;
					}
					if (!field.month) {
						newErrors.admissionTableFieldGroups.month = true;
					}
					if (!field.day) {
						newErrors.admissionTableFieldGroups.day = true;
					}
					if (!field.year || !field.month || !field.day) {
						errorFields.push("Date of birth");
					}
					if (!field.gender) {
						errorFields.push("Gender");
						newErrors.admissionTableFieldGroups.gender = true;
					} else {
						newErrors.admissionTableFieldGroups.gender = false;
					}
					if (field.nationality === null || field.nationality === undefined) {
						errorFields.push("Nationality");
						newErrors.admissionTableFieldGroups.nationality = true;
					} else {
						newErrors.admissionTableFieldGroups.nationality = false;
					}

					// removed this code as the email field is not mandatory.
					// if (field.email === null || field.email === undefined) {
					//   errorFields.push("Email Address");
					//   newErrors.admissionTableFieldGroups.email = true;
					// } else {
					//   newErrors.admissionTableFieldGroups.email = false;
					// }

					if (
						field.email !== null &&
						field.email !== undefined &&
						field.email !== "" &&
						!emailValidate(field.email)
					) {
						swal({
							title: "Warning",
							text: "Staff's email address is not valid. Please enter valid email address.",
						});
						return;
					}
				} else {
					if (
						field.isMandatory &&
						field.fieldTypeCode !== peopleCode &&
						field.fieldTypeCode !== addressCode &&
						(field.value === null ||
							field.value === undefined ||
							field.value === "")
					) {
						errorFields.push(`${field.fieldName} `);
						field.error = true;
					}
				}
			}
		}

		if (errorFields.length > 0) {
			// swal({
			// 	title: `${errorFields.length} mandatory fields are empty.`,
			// 	content: (
			// 		<div className="row">
			// 			{errorFields.map((field, idx) => {
			// 				return (
			// 					// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
			// 					<div className="col-md-6" key={idx}>
			// 						<ul className="text-left">
			// 							<li>
			// 								{field === "academicYear"
			// 									? "Academic Year"
			// 									: field === "staffTypeId"
			// 										? "Staff Type"
			// 										: field === "dateOfHire"
			// 											? "Date of hire"
			// 											: field === "department"
			// 												? "Department"
			// 												: field === "designation"
			// 													? "Designation"
			// 													: field}
			// 							</li>
			// 						</ul>
			// 					</div>
			// 				);
			// 			})}
			// 		</div>
			// 	),
			// 	dangerMode: true,
			// });
			swal("Warning", "Please fill all the mandatory fields above.", "");
			this.setState({
				errors: newErrors,
				admissionTableFieldGroups: newAdmissionTableFieldGroups,
			});
			return;
		}

		//static validation for fields in identity and address clusters
		//student
		// for (let i = 0; i < this.state.admissionTableFieldGroups.length; i++) {
		//   for (
		//     let j = 0;
		//     j < this.state.admissionTableFieldGroups[i].customTableFields.length;
		//     j++
		//   ) {
		//     const field =
		//       this.state.admissionTableFieldGroups[i].customTableFields[j];
		//     if (
		//       this.state.admissionTableFieldGroups[i].customTableFields[j]
		//         .fieldTypeCode === peopleCode
		//     ) {
		//       if (
		//         field.year === null ||
		//         field.month === null ||
		//         field.day === null
		//       ) {
		//         swal({
		//           title: "Warning",
		//           text: "Please insert staff's date of birth. ",
		//         });
		//         return;
		//       }
		//       if (field.gender === null || field.gender === "") {
		//         swal({
		//           title: "Warning",
		//           text: "Please insert staff's gender.",
		//         });
		//         return;
		//       }
		//       if (field.nationality === null || field.nationality === undefined) {
		//         swal({
		//           title: "Warning",
		//           text: "Please insert staff's nationality.",
		//         });
		//         return;
		//       }

		//       // if (
		//       //   field.email === null ||
		//       //   field.email === undefined ||
		//       //   field.email === ""
		//       // ) {
		//       //   const department = this.state.departments.find(
		//       //     (d) => d.id === Number.parseInt(this.state.department)
		//       //   );
		//       //   if (department && department?.label !== "Support & Services") {
		//       //     swal({
		//       //       title: "Warning",
		//       //       text: "Please insert staff's email address.",
		//       //     });
		//       //     return;
		//       //   }
		//       // }
		//       if (
		//         field.email === null ||
		//         field.email === undefined ||
		//         field.email === ""
		//       ) {
		//         const staffType = this.state.staffType.find(
		//           (d) => d.id === Number.parseInt(this.state.staffTypeId)
		//         );
		//         // if (staffType && staffType?.name !== "Support & Services") {
		//         if (staffType && staffType?.code !== "st-suse") {
		//           swal({
		//             title: "Warning",
		//             text: "Please insert staff's email address.",
		//           });
		//           return;
		//         }
		//       }
		//     }
		//     if (
		//       this.state.admissionTableFieldGroups[i].customTableFields[j]
		//         .fieldTypeCode === addressCode
		//     ) {
		//       if (field.country === null || field.country === undefined) {
		//         swal({
		//           title: "Warning",
		//           text: "Please insert staff's country.",
		//         });
		//         return;
		//       }
		//     }
		//     if (
		//       field.email !== null &&
		//       field.email !== undefined &&
		//       field.email !== "" &&
		//       !emailValidate(field.email)
		//     ) {
		//       swal({
		//         title: "Warning",
		//         text: "Staff's email address is not valid. Please enter valid email address.",
		//       });
		//       return;
		//     }
		//   }
		// }

		//for image
		// if (
		//   (this.state.recruitmentImage === null ||
		//     this.state.recruitmentImage === "") &&
		//   !this.props.editMode
		// ) {
		//   swal({
		//     title: "Warning",
		//     text: "Please insert photo of the staff.",
		//   });
		//   return;
		// }

		//for document
		// if (this.state.cv === null && !this.props.editMode) {
		//   swal({
		//     title: "Warning",
		//     text: "Please insert cv document of the staff.",
		//   });
		//   return;
		// }

		const data = {
			id: this.props.recruitmentId,
			staffTypeId: Number.parseInt(this.state.staffTypeId),
			dateOfHire: this.state.dateOfHire,
			// departmentId: Number.parseInt(this.state.department),
			// designationId: Number.parseInt(this.state.designation),
			departmentIds: this.state.selectedDepartments?.map((sd) => sd.id),
			designationIds: this.state.selectedDesignations?.map((sd) => sd.id),
			academicYearId: Number.parseInt(this.state.academicYear),
			recruitmentStatusId: Number.parseInt(this.props.recruitmentStatusId),
			username: this.state.parentCredentials ? this.state.username : null,
			// emergencyContactName: this.state.emergencyContactName,
			// emergencyContactNumber: this.state.emergencyContactNumber,
		};
		const people = {};
		const customTableFieldValues = [];
		const peopleDocument = { documentType: "cv" };
		people.name = "";
		if (this.props.editMode) people.id = this.props.peopleId;
		people.peopleAddresses = [];
		people.peopleDocument = peopleDocument;
		let addressCustomTableFieldValues = [];
		let pushToAddress = {};
		for (const config of this.state.admissionTableFieldGroups) {
			for (const field of config.customTableFields) {
				if (
					field.fieldTypeCode !== addressCode &&
					field.fieldTypeCode !== peopleCode &&
					field.fieldTypeCode !== "table"
				) {
					if (field.isMulti && field.fieldTypeCode === "multi-checkbox") {
						const value = [];
						for (const data of field.customTableFieldDatas) {
							if (field[`data${field.id}`]) {
								value.push(data.data);
							}
						}
						customTableFieldValues.push({
							dbTableId: field.dbTableId,
							customTableFieldId: field.id,
							value: value.join(","),
							groupId: config.id,
						});
					} else if (field.isMulti && field.fieldTypeCode === "radio") {
						customTableFieldValues.push({
							dbTableId: field.dbTableId,
							customTableFieldId: field.id,
							value: field[`value${field.id}`],
							groupId: config.id,
						});
					} else {
						customTableFieldValues.push({
							dbTableId: field.dbTableId,
							customTableFieldId: field.id,
							value: field.value,
							groupId: config.id,
						});
					}
				}

				if (field.fieldTypeCode === peopleCode) {
					people.nationality = field.nationality;
					people.dateOfBirth = new Date(
						`${field.year}-${field.month}-${field.day}`,
					);
					people.gender = field.gender;
					people.emailAddress = field.email;
					people.mobileNumber = field?.mobileNumber;

					for (const cField of this.state.customFields) {
						for (const key of Object.keys(field)) {
							if (cField.fieldName === key) {
								// let joinedValues = `${field['First Name']?.trim()} ${field['Middle Name']?.trim() ?? ''} ${field['Last Name']?.trim()}`;
								let joinedValues = [field['First Name']?.trim(),field['Middle Name']?.trim(),field['Last Name']?.trim()].filter(value => !!value && value !== '').join(' ');
								people.name = joinedValues;
								// people.name = people.name.concat(`${field[key]} `);
								customTableFieldValues.push({
									dbTableId: cField.dbTableId,
									customTableFieldId: cField.id,
									value: field[key],
									groupId: config.id,
								});
							}
						}
					}
				}

				if (field.fieldTypeCode === addressCode) {
					pushToAddress = {};
					addressCustomTableFieldValues = [];
					pushToAddress.countryId = field.country;
					pushToAddress.customTableFieldId = field.id;
					pushToAddress.countryFirstLevelId = field.countryFirstLevelId;
					pushToAddress.countrySecondLevelId = field.countrySecondLevelId;
					pushToAddress.countryThirdLevelId = field.countryThirdLevelId;

					for (const adCField of this.state.addressCustomFields) {
						for (const key of Object.keys(field)) {
							if (adCField.fieldName === key) {
								addressCustomTableFieldValues.push({
									dbTableId: adCField.dbTableId,
									customTableFieldId: adCField.id,
									value: field[key],
									groupId: config.id,
								});
							}
						}
					}

					pushToAddress.addressCustomTableFieldValues =
						addressCustomTableFieldValues;
					people.peopleAddresses.push(pushToAddress);
				}

				if (field.fieldTypeCode === "table") {
					const customFieldTableColumnValues = [];

					for (const column of field.customFieldTableColumns) {
						if (!column.customFieldTableSubColumns?.length) {
							for (const [rowIndex, row] of field.rows.entries()) {
								if (row[column.name] && column.fieldTypeCode === "checkbox") {
									customFieldTableColumnValues.push({
										rowId: row.rowId,
										columnId: column.id,
										groupId: config.id,
										value: row[column.name],
									});
								} else if (
									row[column.name] === undefined &&
									column.fieldTypeCode === "checkbox"
								) {
									customFieldTableColumnValues.push({
										rowId: row.rowId,
										columnId: column.id,
										groupId: config.id,
										value: false,
									});
								} else if (
									column.fieldTypeCode === "radio" &&
									row[`${column.name}${rowIndex}`]
								) {
									customFieldTableColumnValues.push({
										rowId: row.rowId,
										columnId: column.id,
										groupId: config.id,
										value: row[`${column.name}${rowIndex}`],
									});
								} else if (row[column.name]) {
									customFieldTableColumnValues.push({
										rowId: row.rowId,
										columnId: column.id,
										groupId: config.id,
										value: row[column.name],
									});
								}
							}
						} else {
							for (const subCol of column.customFieldTableSubColumns) {
								for (const [rowIndex, row] of column.rows.entries()) {
									if (row[subCol.name]) {
										customFieldTableColumnValues.push({
											rowId: row.rowId,
											columnId: subCol.id,
											groupId: config.id,
											value: row[subCol.name],
										});
									} else if (
										row[subCol.name] === undefined &&
										subCol.fieldTypeCode === "checkbox"
									) {
										customFieldTableColumnValues.push({
											rowId: row.rowId,
											columnId: subCol.id,
											groupId: config.id,
											value: false,
										});
									} else if (
										subCol.fieldTypeCode === "radio" &&
										row[`${subCol.name}${rowIndex}`]
									) {
										customFieldTableColumnValues.push({
											rowId: row.rowId,
											columnId: subCol.id,
											groupId: config.id,
											value: row[`${subCol.name}${rowIndex}`],
										});
									} else if (row[column.name]) {
										customFieldTableColumnValues.push({
											rowId: row.rowId,
											columnId: column.id,
											groupId: config.id,
											value: row[column.name],
										});
									}
								}
							}
						}
					}

					customTableFieldValues.push({
						dbTableId: field.dbTableId,
						customTableFieldId: field.id,
						fieldTypeCode: "table",
						groupId: config.id,
						customFieldTableColumnValues,
					});
				}
			}
		}

		people.customTableFieldValues = customTableFieldValues;
		data.people = people;
		const formData = new FormData();
		// formData.append("recruitment", JSON.stringify(data));
		formData.append("recruitment", JSON.stringify(data, (key, value) => {
			if (typeof value === 'string') {
				return value?.trim();
			}
			return value;
		}));

		formData.append("recruitmentImage", this.state.recruitmentImage);
		formData.append("uploadFile", this.state.cv);

		const endPoint = this.props.editMode
			? URL.recruitmentUpdate
			: URL.recruitmentFormInsert;
		const message = this.props.editMode
			? "Staff data updated successfully"
			: "Recruitment Successfully Inserted";
		this.setState({ isSubmitting: true }, () => {
			axiosPost(
				endPoint,
				formData,
				(response) => {
					if (response.status === 200) {
						swal(MESSAGEHEADER.success, message);
						this.staffStatus();
						!this.props.editMode
							? this.props.getStaffListPagination(3, 0, 10)
							: this.props.handleStaffSearch("noAlphabet");
						document.getElementById("cv").value = "";
						this.setState(
							{
								staffTypeId: !this.props.editMode ? "" : this.state.staffTypeId,
								dateOfHire: !this.props.editMode ? "" : this.state.dateOfHire,
								isSubmitting: false,
								errors: {
									staffTypeId: false,
									dateOfHire: false,
									admissionTableFieldGroups: {},
								},
								selectedDepartments: !this.props.editMode
									? null
									: this.state.selectedDepartments,
								selectedDesignations: !this.props.editMode
									? null
									: this.state.selectedDesignations,
							},
							() => {
								const crudName = this.props.editMode ? "update" : "insert";
								const peopleId = this.props.peopleId;
								!this.props.editMode &&
									this.props.getRecruitmentConfiguration(crudName, peopleId);
							},
						);
					}
				},
				(err) => {
					this.setState({
						isSubmitting: false,
					});
					swal({
						title: "Oops",
						text: `${err.response?.data.message}`,
						allowOutsideClick: false,
						closeOnClickOutside: false,
					});
				},
			);
		});
	};

	render() {
		return this.state.render &&
			this.state.admissionTableFieldGroups?.length > 0 ? (
			<>
				{/* {this.state.isAvailable ? ( */}
				<div
					className="tt-widgetContent-tab-holder"
					style={{ height: "79.5vh" }}
				>
					<div className="tt-group-header">
						Recruitment Form
						{checkWidgetAdminOrNot("Recruitment") === true &&
							!this.props.editMode ? (
							<button
								type="button"
								className="tt-button tt-button-primary float-right permissionBtnCSS"
								onClick={() => {
									this.setState({
										permissionModal: !this.state.permissionModal,
									});
								}}
							>
								Permissions
							</button>
						) : null}
						{(!this.props.editMode &&
							this.state.admissionTableFieldGroups?.length > 0
						) && (
								<button
									type="button"
									className="tt-button tt-button-primary float-right permissionBtnCSS"
									onClick={() => {
										this.setState({
											importModal: !this.state.importModal,
										});
									}}
								>
									Import Data
								</button>
							)}
					</div>
					{!this.state.isLoading ? (
						<div className="tt-newListBox container-fluid">
							<StaffType
								yearOfJoiningToggleDate={this.state.yearOfJoiningToggleDate}
								toggleDatePicker={this.toggleDatePicker}
								dateOfHireInBS={this.state.dateOfHireInBS}
								handleChangeNepaliDate={this.handleChangeNepaliDate}
								staffTypeId={this.state.staffTypeId}
								handleChange={this.handleChange}
								dateOfHire={this.state.dateOfHire}
								errors={this.state.errors}
								schoolEstablishedDate={this.state.schoolEstablishedDate}
								departments={this.state.departments}
								designations={this.state.designations}
								getDesignations={this.getDesignations}
								staffType={this.state.staffType}
								academicYear={this.state.academicYear}
								department={this.state.department}
								designation={this.state.designation}
								editMode={this.props.editMode}
								handleDepartmentChange={this.handleDepartmentChange}
								selectedDepartments={this.state.selectedDepartments}
								selectedDesignations={this.state.selectedDesignations}
								parentCredentials={this.state.parentCredentials}
								username={this.state.username}
								checkisUserAvailable={this.checkisUserAvailable}
								userFetching={this.state.userFetching}
								userFound={this.state.userFound}
								inputForm={true}
							/>
							{this.state.admissionTableFieldGroups
								? this.state.admissionTableFieldGroups.map((el, elIdx) => {
									return (
										// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
										<div key={elIdx}>
											{!el.headerHidden ? (
												<div className="tt-group-header">{el.name}</div>
											) : null}
											{el.customTableFields.map(
												(customTableField, cusIdx) => {
													return (
														// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
														<div key={cusIdx}>
															<div className="form-group row">
																<div className="col-md-1" />
																{customTableField.fieldName === null ||
																	customTableField.fieldName === "" ? null : (
																	<div className="col-md-3">
																		<label htmlFor={`id${cusIdx}`}>
																			<strong>
																				{customTableField.fieldName}{" "}
																				{customTableField.isMandatory && (
																					<span className="tt-assessment-module-mandatory">
																						*
																					</span>
																				)}
																			</strong>
																		</label>
																	</div>
																)}
																<div
																	className={
																		customTableField.fieldName === null ||
																			customTableField.fieldName === ""
																			? "col-md-10"
																			: "col-md-7"
																	}
																>
																	{customTableField.fieldTypeCode ===
																		addressCode ? (
																		<AddressCluster
																			inputForm={true}
																			key={`${
																				// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
																				cusIdx
																				}key`}
																			customTableField={customTableField}
																			handleCustomFieldChange={
																				this.handleCustomFieldChange
																			}
																			studentFieldIndex={elIdx}
																			customTableFieldIndex={cusIdx}
																			stateName="admissionTableFieldGroups"
																			errors={this.state.errors}
																			editMode={this.props.editMode}
																			addressFields={this.state.addressFields}
																			config={false}
																		/>
																	) : customTableField.fieldTypeCode ===
																		peopleCode ? (
																		<IdentityCluster
																			module={"recruitment"}
																			inputForm={true}
																			yearOfJoiningToggleDate={
																				this.state.yearOfJoiningToggleDate
																			}
																			toggleDatePicker={this.toggleDatePicker}
																			icToggleDatePicker={
																				this.icToggleDatePicker
																			}
																			identityClusterDatePickerToggle={
																				this.state
																					.identityClusterDatePickerToggle
																			}
																			dateOfHireInBS={
																				this.state.dateOfHireInBS
																			}
																			studentFieldIndex={elIdx}
																			customTableFieldIndex={cusIdx}
																			stateName="admissionTableFieldGroups"
																			handleBdayChange={this.handleBdayChange}
																			handleDateChange={this.handleDateChange}
																			customFields={this.state.customFields}
																			customTableField={customTableField}
																			handleCustomFieldChange={
																				this.handleCustomFieldChange
																			}
																			handleFileChange={this.handleFileChange}
																			errors={this.state.errors}
																			student={false}
																			editMode={this.props.editMode}
																			identityFields={
																				this.state.identityFields
																			}
																			email={this.state.email}
																			adbsToggler={true}
																			config={false}
																			dateOfBirth={this.props.staffData?.people?.dateOfBirth}
																		/>
																	) : (
																		<>
																			{customTableField.fieldTypeName ===
																				"file" ? (
																				<input
																					type={
																						customTableField.fieldTypeName
																					}
																					name="value"
																					id={`id${cusIdx}`}
																					checked={customTableField.value}
																					onChange={(e) =>
																						this.handleNestedChange(
																							e,
																							elIdx,
																							"admissionTableFieldGroups",
																							cusIdx,
																						)
																					}
																					className={
																						this.state.errors
																							.admissionTableFieldGroups[
																							customTableField.fieldName
																						]
																							? "form-control indicate-error"
																							: customTableField.fieldTypeName ===
																								"file"
																								? ""
																								: "form-control"
																					}
																				/>
																			) : (
																				<div style={{ display: "flex" }}>
																					{customTableField.isMulti &&
																						customTableField.fieldTypeCode !==
																						"select" &&
																						customTableField.fieldTypeCode !==
																						"table" ? (
																						customTableField.customTableFieldDatas.map(
																							(data) => (
																								<React.Fragment key={data.id}>
																									<label
																										htmlFor={`id${cusIdx}`}
																										className="mr-1"
																									>
																										{data.data}
																									</label>
																									<input
																										type={
																											customTableField.fieldTypeCode ===
																												"multi-checkbox"
																												? "checkbox"
																												: customTableField.fieldTypeCode
																										}
																										name={
																											customTableField.fieldTypeCode ===
																												"radio"
																												? `value${customTableField.id}`
																												: `data${customTableField.id}`
																										}
																										defaultChecked={
																											customTableField.value ===
																											data.data
																										}
																										maxLength="255"
																										id={`id${cusIdx}`}
																										value={data.data}
																										onChange={(e) =>
																											this.handleNestedChange(
																												e,
																												elIdx,
																												"admissionTableFieldGroups",
																												cusIdx,
																											)
																										}
																										className={
																											customTableField.error
																												? "indicate-error mr-3"
																												: "mr-3"
																										}
																									/>
																								</React.Fragment>
																							),
																						)
																					) : (
																						<>
																							{customTableField.isMulti &&
																								customTableField.fieldTypeCode ===
																								"select" ? (
																								<select
																									name="value"
																									className={
																										customTableField.error
																											? "form-control indicate-error"
																											: "form-control"
																									}
																									value={
																										customTableField.value
																									}
																									onChange={(e) =>
																										this.handleNestedChange(
																											e,
																											elIdx,
																											"admissionTableFieldGroups",
																											cusIdx,
																										)
																									}
																								>
																									<option disabled selected>
																										Choose a value
																									</option>
																									{customTableField.customTableFieldDatas.map(
																										(data) => (
																											<option
																												key={data.data}
																												value={data.data}
																											>
																												{data.data}
																											</option>
																										),
																									)}
																								</select>
																							) : (
																								<>
																									{customTableField.fieldTypeCode ===
																										"textarea" ? (
																										<textarea
																											name="value"
																											value={
																												customTableField.value
																											}
																											defaultValue={
																												customTableField.value
																											}
																											onChange={(e) =>
																												this.handleNestedChange(
																													e,
																													elIdx,
																													"admissionTableFieldGroups",
																													cusIdx,
																												)
																											}
																											className={
																												customTableField.error
																													? "form-control indicate-error"
																													: "form-control"
																											}
																										/>
																									) : (
																										<>
																											{customTableField.fieldTypeCode ===
																												"table" ? (
																												<TableForm
																													field={
																														customTableField
																													}
																													studentFieldIndex={
																														elIdx
																													}
																													customTableFieldIndex={
																														cusIdx
																													}
																													handleDuplicate={
																														this
																															.handleDuplicate
																													}
																													handleRemoveDuplicate={
																														this
																															.handleRemoveDuplicate
																													}
																													stateName="admissionTableFieldGroups"
																													conf={false}
																													handleCustomFieldTablesChange={
																														this
																															.handleCustomFieldTablesChange
																													}
																												/>
																											) : (
																												<input
																													type={
																														customTableField.fieldTypeCode
																													}
																													name={"value"}
																													maxLength="255"
																													id={`id${cusIdx}`}
																													value={
																														customTableField.value
																													}
																													onChange={(e) =>
																														this.handleNestedChange(
																															e,
																															elIdx,
																															"admissionTableFieldGroups",
																															cusIdx,
																														)
																													}
																													className={
																														customTableField.error
																															? "form-control indicate-error"
																															: "form-control"
																													}
																												/>
																											)}
																										</>
																									)}
																								</>
																							)}
																						</>
																					)}
																				</div>
																			)}
																			{customTableField.mandatory ? (
																				<span className="tt-assessment-module-mandatory">
																					*
																				</span>
																			) : null}
																		</>
																	)}
																	{
																		customTableField?.fieldName !== "" && (
																			<span className={
																				(customTableField.error)
																					? "d-block text-danger"
																					: "d-none"
																			}>{customTableField?.fieldName} cannot be empty*</span>
																		)
																	}
																</div>
																<div className="col-md-1">
																	{this.state.errors[
																		customTableField.fieldName
																	] ? (
																		<span className="error-text">
																			mandatory
																		</span>
																	) : null}
																</div>
															</div>
														</div>
													);
												},
											)}
										</div>
									);
								})
								: null}
							<div>
								<div className="tt-group-header">Documents</div>
								<div className="form-group row">
									<div className="col-md-1" />
									<div className="col-md-3">
										<label htmlFor="cv">
											<strong>CV</strong>
										</label>
									</div>
									<div className="col-md-7">
										<input
											type="file"
											name="cv"
											id="cv"
											// value={this.state.cv}
											onChange={this.handleStaticChange}
											accept="application/pdf"
										/>
									</div>
									<div className="col-md-1" />
								</div>
							</div>
							<div className="form-group row mt-3">
								<div className="col-md-8" />
								<div className="col-md-4 admission-notice">
								</div>
							</div>
							{this.state.admissionTableFieldGroups ? (
								<div className="form-group row">
									<div className="col-md-3" />
									<div className="col-md-8 text-right">
										<button
											type="button"
											className="tt-button tt-button-primary"
											onClick={this.submit}
											disabled={this.state.isSubmitting}
										>
											Submit
										</button>
									</div>
								</div>
							) : null}
						</div>
					) : (
						<div className="text-center" style={{ marginTop: "200px" }}>
							<Spinner color="primary" />
						</div>
					)}

					<ModalWindow
						modal={this.state.permissionModal}
						id="tt-permissionModal"
						size="lg"
						toggleModal={() => {
							this.setState({
								permissionModal: !this.state.permissionModal,
							});
						}}
						modalHeader={"Assign permission to user"}
						modalBody={
							<GranularPermissionModal
								widgetName="Recruitment"
								moduleName="Recruitment"
								header="Create Recruitment"
								activityName="insert-recruitment"
							/>
						}
					/>
					<ModalWindow
						modal={this.state.importModal}
						size="lg"
						toggleModal={() => {
							this.setState({
								importModal: !this.state.importModal,
							});
						}}
						modalHeader={"Import Recruitment Data"}
						modalBody={<ImportRecruitment />}
					/>
					{this.state.isSubmitting ? (
						<div className="fullWindow-Spinner">
							<div>
								<Spinner color="white" />
							</div>
							<div style={{ fontSize: "16px", marginTop: "15px" }}>
								Please wait... {this.props.editMode ? "Updating" : "Creating"}{" "}
								Staff
							</div>
						</div>
					) : null}
				</div>
				{/* ) : (
           <div
             className="tt-widgetContent-tab-holder"
             style={{ height: "79.5vh" }}
           >
             <NoteDisplay
               textContent={`To add a new Recruitment, you must first add departments. Please add departments and then add a new Recruitment`}
             ></NoteDisplay>
           </div>
         )
        } */}
			</>
		) : (
			<div
				className="tt-widgetContent-tab-holder text-center py-3"
				style={{ height: "79.5vh" }}
			>
				{this.state.spinner ? (
					<Spinner color="primary" />
				) : (
					"Recruitment form configuration not found. First configure the form."
				)}
			</div>
		);
	}
}

const mapStateToProps = (state, props) => ({
	recruitmentConfiguration: state.recruitment.recruitmentConfiguration,
});

const mapActionToProps = {
	getRecruitmentConfiguration,
	getStaffList,
	getStaffListPagination,
};

export default connect(mapStateToProps, mapActionToProps)(RecruitmentForm);
